import { Flame, ArrowRight } from "lucide-react";
import useCapacity from "@/lib/useCapacity";
import { EVENT_SOLD_OUT } from "@/lib/tickets";

export default function AnnouncementBar() {
  const { tier, vip_remaining } = useCapacity();
  const scrollTo = (id) =>
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });

  const message = EVENT_SOLD_OUT
    ? "Ще обявим нещо специално на 25.10 — запиши имейла си, за да не го пропуснеш"
    : tier === "sold_out" || vip_remaining <= 0
      ? "РАЗПРОДАДЕНО · Заяви интерес за следващото издание"
      : `Остават само ${vip_remaining} VIP билета — след запълване продажбата приключва`;

  const isLast = EVENT_SOLD_OUT || tier === "last" || vip_remaining <= 20;

  return (
    <div
      data-testid="announcement-bar"
      className={`fixed top-0 left-0 right-0 z-[60] ${isLast ? "bg-[#E5484D] text-white" : "bg-[#F5892E] text-[#0B1F3D]"}`}
    >
      <button
        onClick={() => scrollTo(EVENT_SOLD_OUT ? "notify" : "tickets")}
        data-testid="announcement-cta"
        className="w-full h-9 sm:h-10 flex items-center justify-center gap-2 sm:gap-3 px-4 group"
      >
        <Flame className="w-3.5 h-3.5 sm:w-4 sm:h-4 shrink-0" strokeWidth={2.5} />
        <span
          data-testid="announcement-remaining"
          className="font-mono text-[10px] sm:text-xs uppercase tracking-[0.14em] sm:tracking-[0.2em] font-semibold text-center"
        >
          {message}
        </span>
        <span className="hidden sm:inline-flex items-center gap-1 font-mono text-[11px] uppercase tracking-[0.2em] font-bold underline underline-offset-2 group-hover:gap-2 transition-all">
          {EVENT_SOLD_OUT ? "Запиши се" : "Купи VIP"}
          <ArrowRight className="w-3.5 h-3.5" strokeWidth={2.8} />
        </span>
      </button>
    </div>
  );
}
